import createCardListingView from '../Views/createCardListingView';
import FlexProjectCard from './FlexProjectCard';

export default createCardListingView(FlexProjectCard, {
  displayName: 'ProjectListingView',
});
